module.exports = __webpack_public_path__ + "static/alexa-ce01c7c84d27363fd8305270a4c0f4b0.png";